import React from 'react';
import { useWebSocketListener } from '../../context/useWebSocketListener';
import { WEB_SOCKET_ENTITY_TYPES } from '../../utils/WebSocketUtils';

const InternalNoteDetailListener = ({ socketContext, onMessage, entityIds }) => {
	useWebSocketListener({
		socketContext,
		onMessage,
		entityName: WEB_SOCKET_ENTITY_TYPES.WORK_ORDER_INTERNAL_NOTES,
		entityIds,
	});
	return null;
};

export default InternalNoteDetailListener;
